export default "__VITE_ASSET__DWk$xn5R__"